import React, { useState, useRef, useEffect } from "react";
import { BiInfoCircle, BiLogOut, BiUserCircle } from "react-icons/bi";
import { useNavigate, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logo from "../../assets/evaclogo.png";
import { FiGrid } from "react-icons/fi";
import { IoHomeOutline } from "react-icons/io5";
import { FaRegUser } from "react-icons/fa";

const Navbar = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    window.addEventListener("mousedown", handleClickOutside);
    return () => window.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const logout = () => {
    localStorage.clear();
    toast.success("Logged out", { theme: "light" });
    navigate("/landing");
  };

  const navLinkStyle = (path) =>
    `text-sm font-medium px-3 py-2 rounded-md hover:text-blue-600 flex items-center gap-1 ${
      location.pathname === path ? "text-blue-600 font-medium" : "text-gray-800"
    }`;

  return (
    <nav className="bg-white shadow-sm  w-full ">
      <ToastContainer />
      <div className="custom-container">
        <div className="flex justify-between items-center h-16 ">
          {/* Logo */}
          <div className="flex-shrink-0" onClick={() => navigate("/dashboard")}>
            <img src={logo} alt="logo" className="h-10 w-auto" />
          </div>

          {/* Navigation Links */}
          <div className="flex flex-row">
            <button
              onClick={() => navigate("/dashboard")}
              className={navLinkStyle("/dashboard")}
            >
              <IoHomeOutline className="text-lg" /> <span>Dashboard</span>
            </button>
            <div
              onClick={() => navigate("/chargerScreen")}
              className={navLinkStyle("/chargerScreen")}
            >
              <FiGrid className="text-lg" /> <span>Chargers</span>
            </div>

            <div
              className="relative flex items-center gap-1 cursor-pointer"
              ref={dropdownRef}
            >
              <div
                onClick={() => setShowDropdown(!showDropdown)}
                className={navLinkStyle("/profileScreen") + " cursor-pointer"}
              >
                <FaRegUser className="text-lg" />
                <span>Profile</span>
              </div>
              {showDropdown && (
                <div className="absolute -right-5 top-6 mt-2 w-48 bg-white border rounded-md shadow-lg py-2 z-50">
                  <button
                    onClick={() => navigate("/profileScreen")}
                    className={`w-full text-left px-4 py-2 flex items-center gap-2 hover:bg-gray-100 text-sm ${
                      location.pathname === "/profileScreen"
                        ? "text-blue-600 font-semibold"
                        : "text-gray-700"
                    }`}
                  >
                    <BiUserCircle /> <span>Profile</span>
                  </button>
                  <button
                    onClick={() => navigate("/AboutUs")}
                    className={`w-full text-left px-4 py-2 flex items-center gap-2 hover:bg-gray-100 text-sm ${
                      location.pathname === "/NewAbout"
                        ? "text-blue-600 font-semibold"
                        : "text-gray-700"
                    }`}
                  >
                    <BiInfoCircle /> <span>Legal Docs</span>
                  </button>
                  <button
                    onClick={() => {
                      if (window.confirm("Are you sure ?")) logout();
                    }}
                    className="w-full text-left px-4 py-2 flex items-center gap-2 hover:bg-gray-100 text-sm text-gray-700"
                  >
                    <BiLogOut /> <span>Logout</span>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
